var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center",style:(("height: " + _vm.height + "px; width: 100%; overflow: hiddden"))},[_c('v-progress-circular',{staticStyle:{"width":"100%"},attrs:{"width":"5","color":_vm.color,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }